/**
 * Define los modos claro y oscuro de la interfaz. Sus nombres coinciden con data-theme y
 * los bloques de web/src/styles/theme.css.
 *
 * El modo lo elige quien utiliza el panel o la página publicada. La paleta de la
 * aplicación se configura por separado en shared/brand.ts.
 */

const THEME_NAMES = ["light", "dark"] as const;

export type ThemeName = (typeof THEME_NAMES)[number];

/** Con que modo se muestra lo que nunca eligió uno. */
export const DEFAULT_THEME: ThemeName = "light";

/** Indica si un valor es un modo de tema válido (`light` o `dark`). */
export const isThemeName = (v: unknown): v is ThemeName =>
  typeof v === "string" && (THEME_NAMES as readonly string[]).includes(v);
